import { subDays, addDays, format } from "date-fns";

const lastDateToCurrentDate = (value) => {
  const currentDate = new Date();

  // Subtract `value` days from the current date to get the start date
  const startDate = subDays(currentDate, Number(value));

  // Current date is the end date
  const endDate = currentDate;

  // Format the dates
  const formattedStartDate = format(startDate, "dd/MM/yyyy");
  const formattedEndDate = format(endDate, "dd/MM/yyyy");

  return { formattedStartDate, formattedEndDate };
};

const currentDateToNextDate = (value) => {
  const currentDate = new Date(); // This will create a date in the local time zone.
  // console.log(value);

  // Add `value` days to the current date to get the end date
  const endDate = addDays(currentDate, Number(value) - 1);

  // Format the dates (using local time)
  const formattedStartDate = format(currentDate, "dd/MM/yyyy");
  const formattedEndDate = format(endDate, "dd/MM/yyyy");
  // console.log(formattedStartDate, formattedEndDate);

  return { formattedStartDate, formattedEndDate };
};

const fromThisDateToThisDate = (value) => {
  const currentDate = new Date(); // Current date (local time)

  let startDate;
  let endDate;

  if (value === "Yesterday") {
    startDate = subDays(currentDate, 1); // Subtract 1 day for yesterday
    endDate = startDate; // Same date for start and end (yesterday)
  } else if (value === "Today") {
    startDate = currentDate; // Current date for today
    endDate = startDate; // Same date for start and end (today)
  } else if (value === "Tomorrow") {
    startDate = addDays(currentDate, 1); // Add 1 day for tomorrow
    endDate = startDate; // Same date for start and end (tomorrow)
  } else {
    console.error("Invalid value, please use yesterday, today, or tomorrow");
  }

  // Format the dates
  if (startDate && endDate) {
    const formattedStartDate = format(startDate, "dd/MM/yyyy");
    const formattedEndDate = format(endDate, "dd/MM/yyyy");
    return { formattedStartDate, formattedEndDate };
  } else {
    // console.log("start and end date is undefined");
  }
};
export { lastDateToCurrentDate, currentDateToNextDate, fromThisDateToThisDate };
